import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { path } from '@bo-client/shared/constants/path';
import { FcContractConfirmationComponent } from '@bo-client/activation-management/feeder-contract/fc-contract-confirmation/fc-contract-confirmation.component';
import { CrChimneysweepConfirmationComponent } from '@bo-client/activation-management/commissioning/cr-chimneysweep-confirmation/cr-chimneysweep-confirmation.component';
import { ThankYouComponent } from '@bo-client/shared/components/thank-you/thank-you.component';
import { ErrorPageComponent } from '@bo-client/shared/components/error-page/error-page.component';
import { GrPlaceInServiceConfirmationComponent } from '@bo-client/activation-management/grid-registration/gr-place-in-service-confirmation/gr-place-in-service-confirmation.component';
import { OrderRequestConfirmationComponent } from '@bo-client/nap/order-request-confirmation/order-request-confirmation.component';
import { GrConfirmFeedinOrderComponent } from '@bo-client/activation-management/grid-registration/gr-confirm-feedin-order/gr-confirm-feedin-order.component';
import { GridRegistrationExternalComponent } from '@bo-client/activation-management/grid-registration/grid-registration-external/grid-registration-external.component';
import { GrAssignTechnicianConfirmationComponent } from '@bo-client/activation-management/grid-registration/gr-assign-technician-confirmation/gr-assign-technician-confirmation.component';
import { GridRegistrationExternalFeedbackComponent } from '@bo-client/activation-management/grid-registration/grid-registration-external-feedback/grid-registration-external-feedback.component';
import { GridDisconnectionPageComponent } from '@bo-client/activation-management/commissioning/grid-disconnection-page/grid-disconnection-page.component';
import { GrConfirmExtensionComponent } from '@bo-client/activation-management/grid-registration/gr-confirm-extension/gr-confirm-extension.component';
import { ImsysInstallationPageComponent } from '@bo-client/activation-management/commissioning/imsys-installation-page/imsys-installation-page.component';
import { MeterInspectionPageComponent } from '@bo-client/activation-management/commissioning/meter-inspection-page/meter-inspection-page.component';
import { OrderRequestWizardProxyComponent } from '@bo-client/nap/order-request-wizard/order-request-wizard-proxy/order-request-wizard-proxy.component';
import { OrderRequestWizardEntryComponent } from '@bo-client/nap/order-request-wizard/order-request-wizard-entry/order-request-wizard-entry.component';
import { OrderRequestWizardFeedbackComponent } from '@bo-client/nap/order-request-wizard/order-request-wizard-feedback/order-request-wizard-feedback.component';
import { OrderRequestWizardOfferComponent } from '@bo-client/nap/order-request-wizard/order-request-wizard-offer/order-request-wizard-offer.component';

const routes: Routes = [
  {
    path: path.cmFCContractConfirmation + path.id + path.token,
    component: FcContractConfirmationComponent
  },
  {
    path: path.cmCRChimneySweepConfirmation + path.id + path.token,
    component: CrChimneysweepConfirmationComponent
  },
  {
    path: path.cmGRPlaceInServiceConfirmation + path.id + path.token,
    component: GrPlaceInServiceConfirmationComponent
  },
  {
    path: path.cmGRConfirmFeedinOrder + path.id + path.token,
    component: GrConfirmFeedinOrderComponent
  },
  {
    path: path.hapApproval + path.id + path.token,
    component: OrderRequestConfirmationComponent
  },
  {
    path: path.goToThanksPage + path.message,
    component: ThankYouComponent
  },
  {
    path: path.goToErrorPage + path.message,
    component: ErrorPageComponent
  },
  {
    path: path.cmGridRegistration + path.gridRegType + path.create,
    component: GridRegistrationExternalComponent
  },
  {
    path: path.grAssignTechnician + path.id + path.token,
    component: GrAssignTechnicianConfirmationComponent
  },
  {
    path: path.grRefreshValidity + path.id + path.token,
    component: GrConfirmExtensionComponent
  },
  {
    path: path.cmGridRegistration + path.gridRegType + path.feedback + path.id + path.token,
    component: GridRegistrationExternalFeedbackComponent
  },
  {
    path: path.cmCommissioningManagement + '/disconnection',
    component: GridDisconnectionPageComponent
  },
  {
    path: path.cmCommissioningManagement + '/imsys-installation',
    component: ImsysInstallationPageComponent
  },
  {
    path: path.cmCommissioningManagement + '/inspection',
    component: MeterInspectionPageComponent
  },
  {
    path: path.orderRequestWizard,
    component: OrderRequestWizardEntryComponent
  },
  {
    path: path.orderRequestWizard + '/:area/:type',
    component: OrderRequestWizardProxyComponent
  },
  {
    path: path.hapConnectionChangeRequest + '/feedback' + path.id + path.token,
    component: OrderRequestWizardFeedbackComponent
  },
  {
    path: path.hapConnectionChangeRequest + '/confirm' + path.id + path.token,
    component: OrderRequestWizardOfferComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExternalRoutingModule {}
